module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var selectionTypeConstants = {
	  ATOM: 'Atom',
	  RESIDUE: 'Residue',
	  CHAIN: 'Chain'
	};
	
	exports.default = selectionTypeConstants;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(9);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(10);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib_utils = __webpack_require__(5);
	
	var _lib_utils2 = _interopRequireDefault(_lib_utils);
	
	var _molecule_utils = __webpack_require__(6);
	
	var _molecule_utils2 = _interopRequireDefault(_molecule_utils);
	
	var _selection_types_constants = __webpack_require__(1);
	
	var _selection_types_constants2 = _interopRequireDefault(_selection_types_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	window.$ = _jquery2.default;
	var $3Dmol = __webpack_require__(7);
	
	var DEFAULT_FONT_SIZE = 14;
	var ORBITAL_COLOR_POSITIVE = 0xff0000;
	var ORBITAL_COLOR_NEGATIVE = 0x0000ff;
	var ORBITAL_DEFAULT_OPACITY = 0.8;
	
	var Molecule3d = function (_React$Component) {
	  _inherits(Molecule3d, _React$Component);
	
	  _createClass(Molecule3d, null, [{
	    key: 'isModelDataEmpty',
	    value: function isModelDataEmpty(modelData) {
	      return modelData.atoms.length === 0 && modelData.bonds.length === 0;
	    }
	  }, {
	    key: 'render3dMolModel',
	    value: function render3dMolModel(glviewer, modelData) {
	      glviewer.clear();
	
	      if (Molecule3d.isModelDataEmpty(modelData)) {
	        return;
	      }
	
	      glviewer.addModel(_molecule_utils2.default.modelDataToCDJSON(modelData), 'json', {
	        keepH: true
	      });
	
	      // Hack in chain and residue data, since it's not supported by chemdoodle json
	      glviewer.getModel().selectedAtoms().forEach(function (atom) {
	        var modifiedAtom = atom;
	        var resn = (modelData.atoms[atom.serial].residue_name || '').replace(/[0-9]+/, '');
	        modifiedAtom.atom = modelData.atoms[atom.serial].name;
	        modifiedAtom.chain = modelData.atoms[atom.serial].chain;
	        modifiedAtom.resi = modelData.atoms[atom.serial].residue_index;
	        modifiedAtom.resn = resn;
	      });
	    }
	  }, {
	    key: 'render3dMolShapes',
	    value: function render3dMolShapes(glviewer, shapes) {
	      glviewer.removeAllShapes();
	      shapes.forEach(function (shape) {
	        if (shape.type) {
	          glviewer['add' + shape.type](_lib_utils2.default.getShapeSpec(shape));
	        }
	      });
	    }
	  }, {
	    key: 'render3dMolLabels',
	    value: function render3dMolLabels(glviewer, labels) {
	      glviewer.removeAllLabels();
	      labels.forEach(function (label) {
	        glviewer.addLabel(label.text, label);
	      });
	    }
	  }, {
	    key: 'render3dMolOrbital',
	    value: function render3dMolOrbital(glviewer, orbital) {
	      if (orbital.cube_file) {
	        var volumeData = new $3Dmol.VolumeData(orbital.cube_file, 'cube');
	        glviewer.addIsosurface(volumeData, {
	          isoval: orbital.iso_val,
	          color: orbital.positiveVolumetricColor || ORBITAL_COLOR_POSITIVE,
	          opacity: orbital.opacity || ORBITAL_DEFAULT_OPACITY
	        });
	        glviewer.addIsosurface(volumeData, {
	          isoval: -orbital.iso_val,
	          color: orbital.negativeVolumetricColor || ORBITAL_COLOR_NEGATIVE,
	          opacity: orbital.opacity || ORBITAL_DEFAULT_OPACITY
	        });
	      }
	    }
	  }]);
	
	  function Molecule3d(props) {
	    _classCallCheck(this, Molecule3d);
	
	    var _this = _possibleConstructorReturn(this, (Molecule3d.__proto__ || Object.getPrototypeOf(Molecule3d)).call(this, props));
	
	    _this.onClickAtom = function (glAtom) {
	      var atoms = _this.props.modelData.atoms;
	      var atom = atoms[glAtom.serial];
	      var selectionType = _this.props.selectionType;
	      var newSelectedAtomIds = _molecule_utils2.default.addSelection(atoms, _this.state.selectedAtomIds, atom, selectionType);
	
	      _this.setState({
	        selectedAtomIds: newSelectedAtomIds
	      });
	
	      if (_this.props.onChangeSelection) {
	        _this.props.onChangeSelection(newSelectedAtomIds);
	      }
	    };
	
	    _this.state = {
	      selectedAtomIds: props.selectedAtomIds
	    };
	
	    _this.lastOutline = { width: 0.0 };
	    return _this;
	  }
	
	  _createClass(Molecule3d, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.render3dMol();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        selectedAtomIds: nextProps.selectedAtomIds
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.render3dMol();
	    }
	  }, {
	    key: 'render3dMol',
	    value: function render3dMol() {
	      var _this2 = this;
	
	      if (!this.glviewer && Molecule3d.isModelDataEmpty(this.props.modelData)) {
	        return;
	      }
	
	      var glviewer = this.glviewer || $3Dmol.createViewer((0, _jquery2.default)(this.container), {
	        defaultcolors: $3Dmol.elementColors.rasmol
	      });
	
	      var renderingSameModelData = _molecule_utils2.default.modelDataEquivalent(this.oldModelData, this.props.modelData);
	      if (!renderingSameModelData) {
	        this.lastStylesByAtom = null;
	        Molecule3d.render3dMolModel(glviewer, this.props.modelData);
	      }
	
	      if (this.props.outlineWidth !== this.lastOutline.width || this.props.outlineColor !== this.lastOutline.color) {
	        if (this.props.outlineWidth) {
	          this.lastOutline = {
	            style: 'outline',
	            width: this.props.outlineWidth,
	            color: this.props.outlineColor
	          };
	        } else {
	          this.lastOutline = {};
	        }
	        glviewer.setViewStyle(this.lastOutline);
	      }
	
	      var styleUpdates = Object.create(null); // style update strings to atom ids needed
	      var stylesByAtom = Object.create(null); // all atom ids to style string
	      this.props.modelData.atoms.forEach(function (atom, i) {
	        var selected = _this2.state.selectedAtomIds.indexOf(atom.serial) !== -1;
	        var libStyle = _lib_utils2.default.getLibStyle(atom, selected, _this2.props.atomLabelsShown, _this2.props.styles[i]);
	
	        if (_this2.props.atomLabelsShown) {
	          glviewer.addLabel(atom.name, {
	            fontSize: DEFAULT_FONT_SIZE,
	            position: {
	              x: atom.positions[0],
	              y: atom.positions[1],
	              z: atom.positions[2]
	            }
	          });
	        }
	
	        var libStyleString = JSON.stringify(libStyle);
	        stylesByAtom[atom.serial] = libStyleString;
	
	        // If the style string for this atom is the same as last time, then no
	        // need to set it again
	        if (_this2.lastStylesByAtom && _this2.lastStylesByAtom[atom.serial] === libStyleString) {
	          return;
	        }
	
	        // Initialize list of atom serials for this style string, if needed
	        if (!styleUpdates[libStyleString]) {
	          styleUpdates[libStyleString] = [];
	        }
	
	        styleUpdates[libStyleString].push(atom.serial);
	      });
	
	      this.lastStylesByAtom = stylesByAtom;
	
	      // Set these style types using a minimum number of calls to 3DMol
	      Object.entries(styleUpdates).forEach(function (_ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            libStyleString = _ref2[0],
	            atomSerials = _ref2[1];
	
	        glviewer.setStyle({ serial: atomSerials }, JSON.parse(libStyleString));
	      });
	
	      Molecule3d.render3dMolShapes(glviewer, this.props.shapes);
	      Molecule3d.render3dMolLabels(glviewer, this.props.labels);
	      Molecule3d.render3dMolOrbital(glviewer, this.props.orbital);
	
	      var customSlab = false;
	
	      if (typeof this.props.nearClip === 'number' && typeof this.props.farClip === 'number') {
	        glviewer.setSlab(this.props.nearClip, this.props.farClip);
	        customSlab = true;
	      }
	
	      glviewer.setBackgroundColor(_lib_utils2.default.colorStringToNumber(this.props.backgroundColor), this.props.backgroundOpacity);
	
	      glviewer.setClickable({}, true, this.onClickAtom);
	      glviewer.render();
	
	      if (!this.oldModelData) {
	        glviewer.zoom();
	        glviewer.zoomTo(0.8);
	      }
	
	      if (!renderingSameModelData) {
	        if (!customSlab) glviewer.fitSlab();
	        this.props.onRenderNewData(glviewer);
	      }
	
	      if (!this.glviewer) {
	        // AMV: hack to correctly expand viewer when first rendered
	        var self = this;
	
	        var intId = setInterval(function () {
	          // wait for canvas to be visible
	          if (self.container.children.length > 0 && self.container.children[0].offsetParent) {
	            glviewer.resize();
	            clearInterval(intId);
	          }
	        }, 50); // polling time in ms
	      }
	
	      this.oldModelData = this.props.modelData;
	      this.glviewer = glviewer;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('div', {
	        className: 'molecule-3d',
	        style: {
	          width: this.props.width,
	          height: this.props.height,
	          position: 'relative',
	          margin: '0 auto'
	        },
	        ref: function ref(c) {
	          _this3.container = c;
	        }
	      });
	    }
	  }]);
	
	  return Molecule3d;
	}(_react2.default.Component);
	
	Molecule3d.defaultProps = {
	  atomLabelsShown: false,
	  backgroundOpacity: 1.0,
	  backgroundColor: '#73757c',
	  height: '500px',
	  onRenderNewData: function onRenderNewData() {},
	  orbital: {},
	  selectedAtomIds: [],
	  selectionType: _selection_types_constants2.default.ATOM,
	  shapes: [],
	  labels: [],
	  styles: {},
	  width: '500px',
	  outlineWidth: 0.0,
	  outlineColor: '#000000',
	  nearClip: null,
	  farClip: null
	};
	Molecule3d.propTypes = {
	  atomLabelsShown: _react2.default.PropTypes.bool,
	  backgroundColor: _react2.default.PropTypes.string,
	  backgroundOpacity: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.string,
	  modelData: _react2.default.PropTypes.shape({
	    atoms: _react2.default.PropTypes.array,
	    bonds: _react2.default.PropTypes.array
	  }).isRequired,
	  onChangeSelection: _react2.default.PropTypes.func,
	  onRenderNewData: _react2.default.PropTypes.func,
	  orbital: _react2.default.PropTypes.shape({
	    cube_file: _react2.default.PropTypes.string,
	    iso_val: _react2.default.PropTypes.number,
	    opacity: _react2.default.PropTypes.number,
	    positiveVolumetricColor: _react2.default.PropTypes.string,
	    negativeVolumetricColor: _react2.default.PropTypes.string
	  }),
	  selectedAtomIds: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number),
	  selectionType: _react2.default.PropTypes.oneOf([_selection_types_constants2.default.ATOM, _selection_types_constants2.default.RESIDUE, _selection_types_constants2.default.CHAIN]),
	  shapes: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	  labels: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	  styles: _react2.default.PropTypes.objectOf(_react2.default.PropTypes.object),
	  width: _react2.default.PropTypes.string,
	  nearClip: _react2.default.PropTypes.number,
	  farClip: _react2.default.PropTypes.number,
	  outlineWidth: _react2.default.PropTypes.number,
	  outlineColor: _react2.default.PropTypes.string
	};
	exports.default = Molecule3d;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shapeConstants = {
	  ARROW: 'Arrow',
	  SPHERE: 'Sphere',
	  CYLINDER: 'Cylinder'
	};
	
	exports.default = shapeConstants;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _molecule_3d = __webpack_require__(2);
	
	var _molecule_3d2 = _interopRequireDefault(_molecule_3d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _molecule_3d2.default; /**
	                                          * Copyright 2016 Autodesk Inc.
	                                          *
	                                          * Licensed under the Apache License, Version 2.0 (the "License");
	                                          * you may not use this file except in compliance with the License.
	                                          * You may obtain a copy of the License at
	                                          *
	                                          *     http://www.apache.org/licenses/LICENSE-2.0
	                                          *
	                                          * Unless required by applicable law or agreed to in writing, software
	                                          * distributed under the License is distributed on an "AS IS" BASIS,
	                                          * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                          * See the License for the specific language governing permissions and
	                                          * limitations under the License.
	                                          */

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _shape_constants = __webpack_require__(3);
	
	var _shape_constants2 = _interopRequireDefault(_shape_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_VISUALIZATION_TYPE = 'stick';
	
	/**
	 * Utils for working with the 3dmol.js library
	 */
	var libUtils = {
	  /**
	   * Given a color string (like #abcdef), return its Number representation
	   * If invalid input given, return the input
	   * @param colorString {String}
	   * @returns {Number}
	   */
	  colorStringToNumber: function colorStringToNumber(colorString) {
	    if (colorString.length !== 4 && colorString.length !== 7) {
	      return colorString;
	    }
	    if (colorString[0] !== '#') {
	      return colorString;
	    }
	
	    var colorInt = parseInt(colorString.substr(1, colorString.length - 1), 16);
	
	    if (isNaN(colorInt)) {
	      return colorString;
	    }
	
	    return colorInt;
	  },
	
	
	  /**
	   * Given a shape object from the main model, return a shape spec ready to go into 3Dmol.js
	   * @param shape {Object}
	   * @returns {Object}
	   */
	  getShapeSpec: function getShapeSpec(shape, callback) {
	    var color = void 0;
	    if (shape.color) {
	      color = libUtils.colorStringToNumber(shape.color);
	    }
	
	    var shapeSpec = Object.assign({}, {
	      alpha: 0.8,
	      callback: callback,
	      clickable: false,
	      color: 0x00FE03,
	      radius: shape.radius
	    }, shape, { color: color });
	
	    if (shape.type === _shape_constants2.default.ARROW) {
	      shapeSpec.start = shape.start;
	      shapeSpec.end = shape.end;
	    } else if (shape.type === _shape_constants2.default.SPHERE) {
	      shapeSpec.center = shape.center;
	    } else if (shape.type === _shape_constants2.default.CYLINDER) {
	      shapeSpec.fromCap = true;
	      shapeSpec.toCap = true;
	      shapeSpec.start = shape.start;
	      shapeSpec.end = shape.end;
	    } else {
	      throw new Error('Invalid shape type.');
	    }
	
	    return shapeSpec;
	  },
	
	
	  /**
	   * Get the style object needed by 3dMol for the given atom
	   * @param atom {Object}
	   * @returns {Object}
	   */
	  getLibStyle: function getLibStyle(atom, selected, atomLabelsShown) {
	    var style = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var libStyle = {};
	    var visualizationType = style.visualization_type || DEFAULT_VISUALIZATION_TYPE;
	
	    libStyle[visualizationType] = {};
	    Object.entries(style).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          styleKey = _ref2[0],
	          styleValue = _ref2[1];
	
	      if (styleKey !== 'visualization_type') {
	        libStyle[visualizationType][styleKey] = styleValue;
	      }
	    });
	
	    if (selected) {
	      libStyle[visualizationType].color = 0x1FF3FE;
	    }
	
	    if (typeof libStyle[visualizationType].color === 'string') {
	      libStyle[visualizationType].color = libUtils.colorStringToNumber(libStyle[visualizationType].color);
	    }
	
	    return libStyle;
	  }
	};
	
	exports.default = libUtils;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(8);
	
	var _selection_types_constants = __webpack_require__(1);
	
	var _selection_types_constants2 = _interopRequireDefault(_selection_types_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var moleculeUtils = {
	  /**
	   * Given molecule model data, return a JSON object in ChemDoodle format
	   * @param modelData {Object}
	   * @returns {String}
	   */
	  modelDataToCDJSON: function modelDataToCDJSON(modelData) {
	    var atoms = modelData.atoms.map(function (atom) {
	      return {
	        l: atom.elem,
	        x: atom.positions[0],
	        y: atom.positions[1],
	        z: atom.positions[2],
	        mass: atom.mass_magnitude
	      };
	    });
	
	    var bonds = modelData.bonds.map(function (bond) {
	      return {
	        b: bond.atom1_index,
	        e: bond.atom2_index,
	        o: bond.bond_order
	      };
	    });
	
	    return {
	      m: [{
	        a: atoms,
	        b: bonds
	      }]
	    };
	  },
	
	
	  /**
	   * Return a new selection of atoms considering a clicked atom, the current selection type, and
	   * the currently selected atoms
	   * @param atoms {Array of Atoms}
	   * @param selectedAtoms {Array of Atoms}
	   * @param clickedAtom {Atom}
	   * @param selectionType {String}
	   * @returns {Array of Atoms}
	   */
	  addSelection: function addSelection(atoms, selectedAtoms, clickedAtom, selectionType) {
	    var selectedAtomsOut = selectedAtoms.slice();
	    var clickedIndex = selectedAtoms.indexOf(clickedAtom.serial);
	    var toggleOn = clickedIndex === -1;
	
	    if (selectionType === _selection_types_constants2.default.ATOM) {
	      if (toggleOn) {
	        selectedAtomsOut.push(clickedAtom.serial);
	      } else {
	        selectedAtomsOut.splice(clickedIndex, 1);
	      }
	
	      return selectedAtomsOut;
	    }
	
	    if (toggleOn) {
	      atoms.forEach(function (atom) {
	        if (moleculeUtils.isSameGroup(clickedAtom, atom, selectionType)) {
	          selectedAtomsOut.push(atom.serial);
	        }
	      });
	    } else {
	      selectedAtomsOut = selectedAtomsOut.filter(function (atomSerial) {
	        var atom = atoms[atomSerial];
	        return !moleculeUtils.isSameGroup(clickedAtom, atom, selectionType);
	      });
	    }
	
	    return selectedAtomsOut;
	  },
	
	
	  /**
	   * Returns a boolean indicating if the given atoms are of the same type (residue or chain)
	   * @param atomA {Atom}
	   * @param atomB {Atom}
	   * @param selectionType {String}
	   * @returns {Boolean}
	   */
	  isSameGroup: function isSameGroup(atomA, atomB, selectionType) {
	    if (selectionType === _selection_types_constants2.default.RESIDUE) {
	      return atomA.residue_index === atomB.residue_index;
	    }
	    if (selectionType === _selection_types_constants2.default.CHAIN) {
	      return atomA.chain === atomB.chain;
	    }
	
	    throw new Error('selectionType must be either residue or chain');
	  },
	
	
	  /**
	   * Checks to see if each modelData contains the same atoms and bonds.
	   * Saves time by not checking every last piece of data right now.
	   * Currently checks atom and bond ids, and atom positions
	   * @param modalDataA {Object}
	   * @param modelDataB {Object}
	   * @returns {Boolean}
	   */
	  modelDataEquivalent: function modelDataEquivalent(modelDataA, modelDataB) {
	    if (!modelDataA || !modelDataB) {
	      return false;
	    }
	
	    var atomIdsA = new _immutable.Set(modelDataA.atoms.map(function (atom) {
	      return atom.serial;
	    }));
	    var atomIdsB = new _immutable.Set(modelDataB.atoms.map(function (atom) {
	      return atom.serial;
	    }));
	    var bondRelationsA = new _immutable.Set(modelDataA.bonds.map(function (bond) {
	      return bond.atom1_index + '=>' + bond.atom2_index;
	    }));
	    var bondRelationsB = new _immutable.Set(modelDataB.bonds.map(function (bond) {
	      return bond.atom1_index + '=>' + bond.atom2_index;
	    }));
	
	    var haveSameAtoms = atomIdsA.equals(atomIdsB);
	    var haveSameBonds = bondRelationsA.equals(bondRelationsB);
	
	    if (!haveSameAtoms || !haveSameBonds) {
	      return false;
	    }
	
	    var atomIdsToPositions = new Map();
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = modelDataA.atoms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var atom = _step.value;
	
	        atomIdsToPositions.set(atom.serial, atom.positions || []);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return modelDataB.atoms.every(function (atom) {
	      return atomIdsToPositions.get(atom.serial).every(function (position, index) {
	        var positionsAtomB = atom.positions || [];
	        return positionsAtomB[index] === position;
	      });
	    });
	  }
	};
	
	exports.default = moleculeUtils;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = require("3dmol");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = require("immutable");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = require("jquery");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js